export default __webpack_public_path__ + "static/media/forin.4a3fb9b3.png";